<template>
  <!-- <div
    v-if="visitBookingEnabled || gantryAccessQrEnabled"
    id="validateOtp-page"
    v-resize="setContentHeight"
    :class="[
      { 'inset-box-shadow': !isMobileOrStandaloneMode },
      onsiteMode ? 'bg-blue-radial' : 'bg-teal-radial',
    ]"
  > -->
  <div
    v-if="visitBookingEnabled || gantryAccessQrEnabled"
    id="validateOtp-page"
    v-resize="setContentHeight"
    :class="[
      { 'inset-box-shadow': !isMobileOrStandaloneMode },
      onsiteMode ? 'bg-blue-dark' : 'bg-blue-dark',
    ]"
  >
    <!-- Toolbar -->
    <v-toolbar dark color="transparent" class="pr-1">
        <v-btn icon @click="navigateBackOrHome" style="z-index: 1">
          <v-icon>
            {{
              (visitBookingEnabled && navFromLoginOptions) ? "mdi-window-close" : "mdi-arrow-left"
            }}
          </v-icon>
        </v-btn>
        <v-toolbar-title>Login</v-toolbar-title>
    </v-toolbar>

    <div ref="validateOtpScrollable" class="scrollable box-shadow-inset">
      <v-card
        color="transparent"
        style="height: inherit"
        class="white--text flex-center-container px-5"
        elevation="24"
      >
        <v-form ref="form">
          <div>
            <div v-if="otpChannelValue" class="text-title text-center pb-8">
              Please enter the 6-digit OTP sent to {{ this.otpChannelValue }}
            </div>
            <v-container>
              <v-form ref="validateOtpForm" v-on:submit.prevent>
                <v-row class="no-gutters flex-center-container"
                  ><div class="text-medium mb-2">
                    <v-icon small color="white" style="padding-bottom: 2px"
                      >mdi-information-outline</v-icon
                    >
                    OTP is valid for 5 minutes.
                  </div></v-row
                >
                <v-row class="no-gutters">
                  <v-container class="mb-3">
                    <v-otp-input
                      ref="toFocus"
                      type="number"
                      max-length="1"
                      min="null"
                      :rules="otpInputRules"
                      @finish="onFinish"
                      v-model="otpInput"
                    ></v-otp-input></v-container
                ></v-row>
                <v-row class="no-gutters flex-center-container">
                  <div class="px-3 mb-7" style="width: 100%">
                    <v-btn
                      id="btnLogin"
                      onfocus="this.blur()"
                      color="orange darken-2"
                      large
                      block
                      dark
                      @click="validateOtp"
                      :should-auto-focus="true"
                      x:disabled="!otpEnterComplete"
                    >
                    <div v-if="visitBookingEnabled && navFromLoginOptions">
                      Log In
                    </div>
                    <div v-else>
                      Generate QR Code
                    </div>
                    </v-btn>
                  </div></v-row
                ></v-form
              >
              <v-row class="no-gutters flex-center-container">
                <div class="text-medium">
                  <a v-show="otpTimer.isLoading" class="white--text"
                    >Resend OTP in {{ otpTimer.timerInSeconds }} seconds</a
                  >
                  <a v-show="!otpTimer.isLoading" class="white--text"
                    >Did not receive the OTP?
                    <a href="#" class="white--text" @click="resendOtp"
                      >Resend</a
                    ></a
                  >
                </div>
              </v-row>
            </v-container>
          </div>
        </v-form>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import apiHelper from "@/helpers/apiHelper";
import businessLogic from "@/helpers/businessLogic";

export default {
  name: "ValidateOtp",
  props: {
    otpChannelId: String,
    otpChannelValue: String,
    triggerOtpTimer: Boolean,
  },
  data: () => ({
    otpInput: null,
    localtriggerOtpTimer: false,
    otpInputRules: [
      (value) => !!value || "Required",
      (value) => /(^\d{6}$)/.test(value),
    ],
  }),
  computed: {
    ...mapState(["otpTimer", "preCasAuthState"]),
    ...mapGetters(["visitBookingEnabled", "isEmailMobileLogin", "gantryAccessQrEnabled"]),
    navFromLoginOptions() {
      return this.$route.query.from === 'loginOptions'
    }
  },
  methods: {
    ...mapMutations([
      // "updateTriggerOtpTimer",
      "updateResult",
      "updatePreCasAuthState",
    ]),
    setContentHeight() {
      if (this.$refs.validateOtpScrollable) {
        const heights = this.heights();
        const contentHeight = heights.screen - heights.toolbar - heights.noticeBarHeight;

        this.$refs.validateOtpScrollable.style.height = contentHeight + "px";
      }
    },
    onFinish(otp) {
      this.otpInput = otp;
    },
    goHome() {
      this.$router.push("/");
    },
    navigateBackOrHome() {
      if (this.navFromLoginOptions) {
        this.goHome()
      } else {
        this.goBack()
      }
    },
    async validateOtp() {
      const validationResult = this.$refs.form.validate();

      if (validationResult) {
        const response = await apiHelper.validateOtp(
          this.otpChannelId,
          this.otpChannelValue,
          this.otpInput
        );

        if (response && response.data) {
          window.$NotFirstRouting = true;

          businessLogic.updateAccountStateAfterLogin(response);

          if (this.gantryAccessQrEnabled && !this.navFromLoginOptions && this.authenticated) {

            const qrCodeResponse = await apiHelper.getGantryAccessQr();

            businessLogic.updateQrCodeValue(qrCodeResponse.data.encryptedQrCode)
          }

          const preCasAuthState = this.preCasAuthState;
          if (preCasAuthState) {
            // console.debug("preCasAuthState.routeName", preCasAuthState.routeName)

            this.updatePreCasAuthState(null);

            if (this.gantryAccessQrEnabled && !this.navFromLoginOptions) {
              this.$router.push({ name: "GantryAccessQR" });
            }
            else {
              this.$router.push({
                name: preCasAuthState.routeName,
                query: { reload: true },
              });
            }
          } else {
                this.$router.push({ name: "Home" });
          }
        } else {
          this.updateResult({
            show: true,
            success: false,
            title: window.$msg.loginFail,
            message: window.$msg.invalidOtp,
          });

          // if (response === window.$msg.reloginRequired) {
          //   setTimeout(() => {
          //     businessLogic.logout();
          //   }, 3000);
          // } else {
          //   //  next({ name: "Home" });
          //   this.$router.replace({ name: "Home" });
          // }
        }
      }
    },
    async resendOtp() {
      if (this.visitBookingEnabled || this.gantryAccessQrEnabled) {
        const triggerOtpTimer = true;

        businessLogic.isOtpTimerRunning(
          window.$settings.resendOtpTimeIntervalInSeconds,
          this.time.nowMoment.format(),
          triggerOtpTimer
        );
      }

      const response = await apiHelper.requestOtp(
        this.otpChannelId,
        this.otpChannelValue
      );

      this.commonResponseHandler(
        response,
        window.$msg.otpGenerateSuccess,
        window.$msg.otpGenerateFail,
        null,
        null,
        null
      );
    },
  },
  activated() {
    this.$nextTick(() => this.setContentHeight());
    this.$nextTick(() => this.$refs.toFocus.focus());

    this.otpInput = null;

    if (this.triggerOtpTimer) {
      this.localtriggerOtpTimer = true;
    }

    // if (this.authenticated) {
    //   this.$router.push({ name: "Home" });
    // }

    // if (!this.otpChannel) {
    //   this.$router.push({ name: "EmailMobileLogin" });
    // }
    if (this.visitBookingEnabled || this.gantryAccessQrEnabled) {
      businessLogic.isOtpTimerRunning(
        window.$settings.resendOtpTimeIntervalInSeconds,
        this.time.nowMoment.format(),
        this.localtriggerOtpTimer
      );
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.authenticated) {
        return next({ name: "Home" });
      } else {
        if (vm.visitBookingEnabled || vm.gantryAccessQrEnabled) {
          next();
        } else {
          apiHelper.casAuth();
        }
      }

      if (!vm.otpChannelValue) {
        return next({ name: "EmailMobileLogin" });
      } else {
        next();
      }
    });
  },
};
</script>

<style>
.v-text-field {
  margin-left: 3px !important;
  margin-right: 3px !important;
}
.v-text-field--outlined .v-input__control .v-input__slot {
  min-height: 50px;
}
</style>
